import {
  LeavePageActions,
  LeavePageActionTypes,
  UpdateFormDirtyStatus
} from '@app/core/leave-page-handler/actions/leave-page';
import {
  LeavePageInternalActions,
  LeavePageInternalActionTypes,
  SetNextPageUrl,
  UpdateLeavePageActionResult
} from '@app/core/leave-page-handler/actions/leave-page-internal';
import { LeavePageActionResult } from '@app/core/leave-page-handler/models/leave-page-action-result';
import { createHandler, createReducer, hasValue } from '@app/util';
import * as R from 'ramda';

export interface FormStatusInfo {
  formDirty: boolean;
}

export interface State {
  formStatusInfo: FormStatusInfo;
  action: LeavePageActionResult;
  nextPageUrl: string;
}

// selectors
export const isConfirmAction = R.allPass([hasValue, R.equals(LeavePageActionResult.Confirm)]);
export const isCancelAction = R.allPass([hasValue, R.equals(LeavePageActionResult.Cancel)]);

export const initialState: State = {
  formStatusInfo: {
    formDirty: false
  },
  action: null,
  nextPageUrl: null
};

const updateFormDirtyStatus = (state: State, {payload: {formDirty}}: UpdateFormDirtyStatus): State =>
  R.mergeRight(state, {formStatusInfo: {...state.formStatusInfo, formDirty}});

const updateLeavePageAction = (state: State, {payload: {action}}: UpdateLeavePageActionResult): State =>
  R.mergeRight(state, {action});

const setNextPageUrl = (state: State, {payload: {nextPageUrl}}: SetNextPageUrl): State =>
  R.mergeRight(state, {nextPageUrl});

const updateFormDirtyStatusHandler = createHandler(LeavePageActionTypes.UpdateFormDirtyStatus, updateFormDirtyStatus);
const updateLeavePageActionResultHandler = createHandler(LeavePageInternalActionTypes.UpdateLeavePageActionResult, updateLeavePageAction);
const setNextPageUrlHandler = createHandler(LeavePageInternalActionTypes.SetNextPageUrl, setNextPageUrl);

type Actions = LeavePageInternalActions | LeavePageActions;
export const reducer = createReducer<State, Actions>([
  updateFormDirtyStatusHandler,
  updateLeavePageActionResultHandler,
  setNextPageUrlHandler
], initialState);

export function leavePageReducer(
  state: State = initialState,
  action: LeavePageActions
): State {
  return reducer(state, action);
}
